import { useMemo, useState } from 'react';

import { Entities_Modules_Module } from '@suntex.fim/api-client';
import { useAuth } from '@suntex.fim/auth/react';
import { Button, VideoModal } from '@suntex.fim/ui';

export function HelpText({
  module,
  label,
}: {
  module?: Entities_Modules_Module;
  label?: string;
}) {
  const { login } = useAuth();
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const { mediaId, friendlyName } = useMemo(
    () => extractMediaInfo(module?.helpText || ''),
    [module?.helpText],
  );

  return (
    module?.helpText &&
    login && (
      <>
        <Button
          aria-label={label ? `Show me how to play ${label}` : undefined}
          intent="secondary"
          size="small"
          onClick={() => {
            setIsVideoOpen(true);
          }}
        >
          Show me how to play
        </Button>
        <VideoModal
          open={isVideoOpen}
          onClose={() => setIsVideoOpen(false)}
          title={friendlyName ?? undefined}
          mediaId={mediaId ?? undefined}
        />
      </>
    )
  );
}

function extractMediaInfo(text: string): {
  mediaId: string | null;
  friendlyName: string | null;
} {
  const mediaIdMatch = text.match(/mediaId=([^&]+)/);
  const friendlynameMatch = text.match(/friendlyname=([^"]+)/);

  return {
    mediaId:
      mediaIdMatch && mediaIdMatch[1]
        ? decodeURIComponent(mediaIdMatch[1])
        : null,
    friendlyName:
      friendlynameMatch && friendlynameMatch[1]
        ? decodeURIComponent(friendlynameMatch[1].replace(/&amp;/g, '&'))
        : null,
  };
}
